module.exports = __webpack_public_path__ + "static/2-2661e92b4d29c4168415c2ab67ee0c48.jpg";